import { getSHA256Hash } from '../../../utils/sha256';

const formatPrice = num => Math.round((num + Number.EPSILON) * 100) / 100;

const addAdvancedData = async (obj, order) => {
  if (!!order.userEmail) {
    obj.sha256_email_address = await getSHA256Hash(order.userEmail);
  }
  if (!!order.billing) {
    if (!!order.billing.phone) {
      obj.sha256_phone_number = await getSHA256Hash(order.billing.phone);
    }
    if (!!order.billing.firstname) {
      obj.address = {
        ...obj.address,
        sha256_first_name: await getSHA256Hash(order.billing.firstname),
      };
    }
    if (!!order.billing.lastname) {
      obj.address = {
        ...obj.address,
        sha256_last_name: await getSHA256Hash(order.billing.lastname),
      };
    }
    if (!!order.billing.address1) {
      obj.address = {
        ...obj.address,
        street: order.billing.address1,
      };
    }
    if (!!order.billing.city) {
      obj.address = {
        ...obj.address,
        city: order.billing.city,
      };
    }
    if (!!order.billing.province) {
      obj.address = {
        ...obj.address,
        region: order.billing.province,
      };
    }
    if (!!order.billing.zipcode) {
      obj.address = {
        ...obj.address,
        postal_code: order.billing.zipcode,
      };
    }
    if (!!order.billing.country) {
      obj.address = {
        ...obj.address,
        country: order.billing.country,
      };
    }
  }
  return obj;
};

export async function gAdsConversion(order, trackingId, goalId) {
  try {
    if (!!window.gAdsTag && !!order) {
      let obj = {
        send_to: `${trackingId}/${goalId}`,
        transaction_id: order.id,
        value: order.revenue,
        currency: 'EUR',
      };
      obj = await addAdvancedData(obj, order);

      window.gAdsTag('event', 'conversion', obj);
    }
  } catch (err) {
    console.error('gtTagAds Error', err);
  }
}

export function gAdsPurchase(order, trackingId, goalId, store, merchantId) {
  try {
    if (!!window.gAdsTag && !!order) {
      // 1 sconto sui prodotti
      const discountProducts = order.items.reduce((acc, curr) => {
        return acc + (curr.listPrice - curr.price) * curr.quantity;
      }, 0);

      // 2 sconto sulle spedizioni
      const shippingCategory = order.items.reduce((acc, curr) => {
        return acc > curr.shippingCategory ? acc : curr.shippingCategory;
      }, 0);

      const discountShippings =
        order.shipping.typeName === 'Corriere Espresso' &&
        order.grandTotal > store.costiSpedizione.freeShippingThreshold
          ? store.glsShipping[`priceCategory${shippingCategory}`]
          : 0;

      // 3 coupon
      const totalProducts = order.items.reduce((acc, curr) => {
        return acc + curr.price * curr.quantity;
      }, 0);
      let discountCoupon = 0;
      if (!!order.coupon) {
        if (!!order.coupon.discountFixed) {
          discountCoupon = order.coupon.discountFixed;
        } else {
          discountCoupon =
            (totalProducts * (order.coupon.discountPercent || 0)) / 100;
        }
      }

      const totalDiscounts = formatPrice(
        discountProducts + discountShippings + discountCoupon
      );

      let obj = {
        send_to: `${trackingId}/${goalId}`,

        transaction_id: order.id,
        value: order.revenue,
        currency: 'EUR',

        // Start of CwCD Parameters
        discount: totalDiscounts,

        items: order.items.map(item => ({
          id: item.productId,
          quantity: item.quantity,
          price: item.listPrice,
          // price: item.price
        })),
      };

      if (!!merchantId) {
        obj = {
          ...obj,
          aw_merchant_id: merchantId, // OPTIONAL
          aw_feed_country: 'IT', // OPTIONAL
          aw_feed_language: 'IT', // OPTIONAL
        };
      }

      window.gAdsTag('event', 'purchase', obj);
    }
  } catch (err) {
    console.error('gtTagAds Error', err);
  }
}
